<template>
  <div
    class="order-list x-scrollbar-show"
    data-automation="OrderList"
    v-infinite-scroll="loadOrderList"
    infinite-scroll-immediate="immediate"
  >
    <template v-if="hasOrder">
      <div
        v-for="(order, idx) in orderData"
        :class="['order-card', { active: currentOrder.id === order.id }]"
        :key="order.id"
        @click="onClickOrder(idx)"
      >
        <div
          :class="[
            'order-item',
            { 'order-unread': String(order.message_status) === '0' },
            { 'order-close': String(order.order_status) === '3' }
          ]"
        >
          <!-- 头部 -->
          <div class="order-header">
            <p class="order-id">{{ $t('HT.orderList.oid') }}: {{ order.work_id }}</p>
            <p class="order-state">{{ stateMap[order.order_status] }}</p>
          </div>

          <!-- 简介 -->
          <p class="order-desc">{{ order.describe }}</p>

          <!-- 底部 -->
          <div class="order-footer">
            <div class="order-img">
              <template v-if="order.imgNum">
                <i class="ux_icon_picture"></i>
                <span>{{ order.imgNum }}</span>
              </template>
            </div>

            <p class="order-time">{{ order.update_time }}</p>
          </div>
        </div>
      </div>
      <p class="order-scroll-txt" v-if="isLoading">{{ $t('HT.loading') }}...</p>
      <p class="order-scroll-txt" v-if="noMore">{{ $t('HT.orderList.nomore') }}</p>
    </template>

    <!-- 缺省页 -->
    <div v-else class="order-list-nodata">
      <default-graph type="8" :text="$t('HT.orderList.nodate')"></default-graph>
    </div>
  </div>
</template>

<script>
import defaultGraph from '@c/defaultGraph/defaultGraph';

export default {
  name: 'OrderList',
  components: {
    defaultGraph
  },
  props: {
    // 工单信息
    orderData: {
      type: Array,
      default: []
    },
    // 总条数
    orderTotal: {
      type: Number,
      default: 0
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      immediate: false, // 是否立即执行加载方法
      // 当前选中
      currentOrder: {},
      // 状态对应关系
      stateMap: {
        1: this.$t('HT.orderList.state1'),
        2: this.$t('HT.orderList.state2'),
        3: this.$t('HT.orderList.state3')
      }
    };
  },

  methods: {
    // 点击工单
    onClickOrder(idx) {
      this.$emit('on-click-order', idx);
      this.currentOrder = JSON.parse(JSON.stringify(this.orderData[idx]));
    },
    // 加载更多
    loadOrderList() {
      if (this.noMore) return;
      this.$emit('load-more');
    }
  },

  computed: {
    // 没有更多信息
    noMore() {
      const len = this.orderData.length;
      return len >= this.orderTotal;
    },

    // 有工单
    hasOrder() {
      return this.orderData.length > 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.order-list {
  .order-card {
    width: 100%;
    height: 128px;
    background: #fff;
    transition: all 0.2s;

    &:hover,
    &.active {
      background: $color-bg-disable;
    }
  }

  .order-item {
    width: 280px;
    margin-left: 20px;
    height: 128px;
    border-bottom: 1px solid $color-disable;
    cursor: pointer;

    &.order-unread {
      .order-id::before {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        right: -16px;
        margin-top: -4px;
        width: 8px;
        height: 8px;
        background: $color-error;
        border-radius: 50%;
      }
    }

    &.order-close {
      .order-desc,
      .order-footer,
      .order-state,
      .order-img {
        color: $color-text-disable;
      }
    }
  }

  .order-header {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .order-id {
    position: relative;
    color: $color-text-secondary;
    font-size: 12px;
    line-height: 16px;
  }

  .order-state {
    color: $color-primary;
    flex: 0 0 auto;
    font-size: 12px;
    line-height: 16px;
  }

  .order-desc {
    width: 100%;
    height: 40px;
    font-size: 14px;
    font-weight: 400;
    color: $color-title;
    line-height: 20px;
    margin-bottom: 8px;
    overflow: hidden; //超出的文本隐藏
    display: -webkit-box;
    -webkit-line-clamp: 2; // 超出多少行
    -webkit-box-orient: vertical;
  }

  .order-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: $color-text-secondary;
    font-size: 12px;
    line-height: 16px;
  }

  .order-img {
    color: $color-text-secondary;
    display: flex;
    align-items: center;

    i {
      font-size: 16px;
    }
  }

  .order-scroll-txt {
    text-align: center;
    color: $color-text-secondary;
    padding: 16px 0;
  }

  .order-list-nodata {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
